import { Webcast } from "JS/Models/Events";
import { config } from "JS/Config";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";

interface WebcastsApiResponse {
    webcasts: Webcast[];
}

export class WebcastService extends BaseService {
    public async getWebcasts(): Promise<Webcast[]> {
        try {
            const response = await this.ngCall<WebcastsApiResponse>(
                "get",
                appConstants.ngEndpoints.webcasts(config.user.memberId),
            );

            const webcasts = response.data?.webcasts || [];

            if (webcasts.length === 0) {
                throw new Error("No webcasts");
            }

            return webcasts;
        } catch (err) {
            throw err;
        }
    }
}
